import { render, staticRenderFns } from "./SmallModalComponent.vue?vue&type=template&id=39d60cd6&"
import script from "./SmallModalComponent.vue?vue&type=script&lang=js&"
export * from "./SmallModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./SmallModalComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports